import styled from 'styled-components';
import { motion as Motion } from 'framer-motion';

export const Hero__Header = styled(Motion.header)`
    position: relative;
    z-index: 2;
    height: inherit;
`;
